<div class="report__link mt-2 flex items-center gap-2" (click)="createReport()">
  <div inlineSVG="landing/information.svg"></div>
  <span translate>Report this post</span>
</div>

@if (isAllowReportModel()) {
  <app-modal
    size="sm"
    btnCancelName="Cancel"
    [btnSubmits]="[
      {
        id: 'submit',
        title: 'Report',
        name: 'report',
      },
    ]"
    (onClose)="isAllowReportModel.set(false)"
    (onSubmit)="submit()"
  >
    <div class="report__header flex flex-col gap-4 text-center pt-4">
      <h2 translate>Report this post</h2>
      <p translate>
        Thanks for help us to improve our services ... we appreciate your
        feedback
      </p>
    </div>
    <form
      [formGroup]="form"
      novalidate
      class="grid grid-cols-2 gap-4 overflow-y-auto py-4 px-4"
    >
      @for (reason of postReportReasonList; track $index) {
        <input-radio-fancy
          [options]="{
            label: reason.label,
            description: reason.description,
            icon: reason.iconPath,
            control: form.controls.reason,
            name: 'reason',
            value: reason.value,
          }"
        ></input-radio-fancy>
      }

      @if (form.controls.reason.value === PostReportReasonEnum.OtherReasons) {
        <input-textarea
          [options]="{
            label: 'Enter custom reason',
            control: form.controls.description,
            isShowErrors: isShowErrors(),
          }"
        ></input-textarea>
      }
    </form>
  </app-modal>
}
